module.exports = __webpack_public_path__ + "assets/img/newQuestionbronzemedal@2x.665c6b07.png";